






























import { Component, Vue } from "vue-property-decorator";
import { mapMutations, mapState } from "vuex";

@Component({
    methods: {
        ...mapMutations(["closeDetailPanel"])
    },
    computed: {
        ...mapState(["detailPanel", "labels"])
    }
})
export default class PanelDetailsComponent extends Vue {
    mounted() {
        this.init()
    }

    // Add focus to be able to use key events
    private init(): void {
        (this.$refs.panelDetail as HTMLElement).focus();
    }
}
